import React from 'react';
import PropTypes from 'prop-types';

class Tab extends React.Component{

    render() {
        return (
            <a 
                onClick={() => this.props.onClick(this.props.tabName)} 
                className={`tab ${this.props.currentTab ? 'tab-active' : ''}`}>
                <span>{this.props.tabName}</span>
            </a>
        );
    }
}

Tab.propTypes = {
    tabName: PropTypes.string.isRequired,
    currentTab: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
}

export default Tab;


/** WEBPACK FOOTER **
 ** ./src/components/ui/Tab.js
 **/